import Vue from 'vue';

const state = {
  calls: [],
};

const TERMINAL_STATUSES = ['completed', 'rejected', 'no_answer', 'no-answer', 'failed'];

export const getters = {
  activeCall: $state => $state.calls.find(call => call.isActive) || null,
  hasActiveCall: $state => $state.calls.some(call => call.isActive),
  incomingCalls: $state => $state.calls.filter(call => !call.isActive),
  hasIncomingCall: $state => $state.calls.some(call => !call.isActive),
  callsByConversation: $state => conversationId =>
    $state.calls.filter(call => call.conversationId === conversationId),
};

export const actions = {
  addCall: ({ commit }, callData) => {
    commit('ADD_CALL', callData);
  },
  removeCall: ({ commit }, callSid) => {
    commit('REMOVE_CALL', callSid);
  },
  setCallActive: ({ commit }, callSid) => {
    commit('SET_CALL_ACTIVE', callSid);
  },
  clearActiveCall: ({ commit }) => {
    commit('CLEAR_ACTIVE_CALL');
  },
  updateCallStatus: ({ commit }, { callSid, status, ...rest }) => {
    commit('UPDATE_CALL', { callSid, status, ...rest });
  },
  removeCallsForConversation: ({ commit }, conversationId) => {
    commit('REMOVE_CALLS_FOR_CONVERSATION', conversationId);
  },
};

export const mutations = {
  ADD_CALL($state, callData) {
    if (!callData?.callSid) return;
    const existing = $state.calls.find(c => c.callSid === callData.callSid);
    if (existing) {
      Object.assign(existing, callData);
      return;
    }
    $state.calls.unshift({ isActive: false, ...callData });
    Vue.set($state.calls, 0, { ...$state.calls[0] });
  },
  REMOVE_CALL($state, callSid) {
    $state.calls = $state.calls.filter(c => c.callSid !== callSid);
  },
  SET_CALL_ACTIVE($state, callSid) {
    $state.calls = $state.calls.map(call => ({
      ...call,
      isActive: call.callSid === callSid,
    }));
    Vue.set($state, 'calls', [...$state.calls]);
  },
  CLEAR_ACTIVE_CALL($state) {
    $state.calls = $state.calls.filter(call => !call.isActive);
    Vue.set($state, 'calls', [...$state.calls]);
  },
  UPDATE_CALL($state, { callSid, status, ...rest }) {
    const callIndex = $state.calls.findIndex(c => c.callSid === callSid);
    if (callIndex === -1) return;
    const call = $state.calls[callIndex];
    Object.assign(call, rest);
    if (status) Vue.set(call, 'status', status);
    Vue.set($state.calls, callIndex, { ...call });
    if (TERMINAL_STATUSES.includes(status)) {
      $state.calls = $state.calls.filter(c => c.callSid !== callSid);
    }
    Vue.set($state, 'calls', [...$state.calls]);
  },
  REMOVE_CALLS_FOR_CONVERSATION($state, conversationId) {
    $state.calls = $state.calls.filter(
      call => call.conversationId !== conversationId
    );
    Vue.set($state, 'calls', [...$state.calls]);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
